import api from '../services/api';
import { isAccessTokenValid } from './AuthController';

export const getAllScreeningQuestion = async (lang) => {
    try {
        await isAccessTokenValid();
        const response = await api.get('/screening-question', { params: { lang: lang } });
        return response.data.data;
    } catch (error) {
        throw error.response?.data || error.message;
    };
};

export const getScreeningQuestionByID = async (id) => {
    try {
        await isAccessTokenValid();
        const response = await api.get(`/screening-question/${id}`);
        return response.data.data;
    } catch (error) {
        throw error.response?.data || error.message;
    };
};

export const updateScreeningQuestion = async (id, data) => {
    try {
        await isAccessTokenValid();
        const response = await api.put(`/screening-question/${id}`, data);
        return response.data.data;
    } catch (error) {
        throw error.response?.data || error.message;
    };
};
